import { useState, useEffect, useContext } from "react";
import {
  GoogleMap,
  useJsApiLoader,
  Marker,
  OverlayView,
} from "@react-google-maps/api";
import HospitalCard from "../../UI/HospitalCard/HospitalCard";
import SearchProvider from "../../Provider/SearchProvider";
import { useSearchParams, useNavigate } from "react-router-dom";
import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  SearchOutlined,
  FilterOutlined,
  ClearOutlined,
} from "@ant-design/icons";
import { Input, Cascader, Breadcrumb } from "antd";
import NoData from "../../UI/NoData/NoData";
import { Flex, Spin } from "antd";
import Meta from "../../Meta/Meta";
const { Search } = Input;
const SearchPage = () => {
  const navigate = useNavigate();
  const {
    searchLoader,
    getSearchData,
    searchData,
    searchTable,
    setSearchTable,
    areaFilterData,
    areaFilterLoader,
    getAreaFilter,
    getPincodeData,
    pincodeLoader,
    setPincodeLoader,
    locationData,
    setLocationData,
  } = useContext(SearchProvider);
  // console.log("locationData", locationData);
  const [searchParams, setSearchParams] = useSearchParams();
  const [center, setCenter] = useState({
    lat: 11.028154, // Default latitude
    lng: 76.947477, // Default longitude
  });

  useEffect(() => {
    if (locationData.length > 0) {
      const firstLocation = locationData[0];
      setCenter({
        lat: parseFloat(firstLocation.lat),
        lng: parseFloat(firstLocation.lng),
      });
    }
  }, [locationData]);
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyAv9vVoTd-ub3Ti8Tip3KHYY5Q8LpHeGhs",
  });
  const [selectedCascaderValue, setSelectedCascaderValue] = useState(null); //
  useEffect(() => {
    getSearchData(searchParams.get("search"));
    getAreaFilter();
  }, [searchTable, searchParams]);
  useEffect(() => {
    const existingScript = document.querySelector(
      `script[src*="maps.googleapis.com"]`
    );
    if (existingScript) {
      // console.log("Google Maps API script already loaded");
    }
  }, []);
  useEffect(() => {
    getPincodeData();
  }, []);
  useEffect(() => {
    if (searchData && searchData.length > 0) {
      const firstClinic = searchData[0];
      const lat = parseFloat(firstClinic.latitude);
      const lng = parseFloat(firstClinic.longitude);
      setCenter({ lat, lng });
    }
  }, [searchData]);

  const mapContainerStyle = {
    width: "100%",
    height: "80vh",
  };
  const onSelectHospital = (lat, lng) => {
    setCenter({ lat: parseFloat(lat), lng: parseFloat(lng) });
  };

  const onAreaChange = (value) => {
    if (!value?.length) {
      // Reset filters if no value is selected
      setSearchTable((prev) => ({
        ...prev,
        province_id: "",
        district: "",
        secretariats_id: "",
      }));
      return;
    }

    // Update based on selected values
    const [province_id = "", district = "", secretariats_id = ""] = value;
    setSelectedCascaderValue(value);
    setSearchTable((prev) => ({
      ...prev,
      province_id,
      district,
      secretariats_id,
    }));
  };
  const handleClearFilters = () => {
    setSelectedCascaderValue(null); // Clear Cascader selection
    setSearchTable({
      clinic_id: "",
      clinic_slug: "",
      province_id: "",
      secretariats_id: "",
      district: "",
      pincode: "",
      id: "",
      search: "",
      page: 1,
      limit: 5,
    });
    setSearchParams({});
    onAreaChange(null); // Clear Cascader-related values
  };

  return (
    <>
      <Meta slug="search" />
      <section className="my-[2rem]">
        <div className="container">
          <div className="mb-[4vh]">
            <Breadcrumb
              separator="/"
              items={[
                {
                  title: "Home",
                  href: "/",
                },
                {
                  title: "Search",
                },
              ]}
            />
          </div>
          <div className="flex flex-col lg:flex-row gap-5 justify-between">
            <div className="w-full lg:w-[calc(70%-7rem)] relative ">
              <div className="sticky top-[20vh]">
                {!isLoaded ? (
                  <div className="flex justify-center items-center h-[70vh]">
                    <Spin size="large" />
                  </div>
                ) : searchData?.data?.length > 0 ? (
                  <GoogleMap
                    mapContainerStyle={mapContainerStyle}
                    center={center}
                    zoom={13}
                  >
                    {Array.isArray(locationData) &&
                      locationData.map((item, index) => (
                        <OverlayView
                          key={index}
                          position={{
                            lat: parseFloat(item.lat),
                            lng: parseFloat(item.lng),
                          }}
                          mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                        >
                          <div
                            className="pin"
                            onClick={() => {
                              navigate(`/search?search=${item?.name}`);
                              setSearchTable({
                                ...searchTable,
                                search: item?.name,
                              });
                            }}
                          >
                            <div className="pin-circle">
                              <div className="value">
                                <img
                                  src={`${process.env.REACT_APP_BASE}${item?.img}`}
                                  alt="Custom Marker"
                                />
                              </div>
                            </div>
                          </div>
                        </OverlayView>
                      ))}
                  </GoogleMap>
                ) : (
                  <NoData title="No Clinic Found" />
                )}
              </div>
            </div>
            <div className="w-full lg:w-[calc(30%-20px)]">
              <div className="flex justify-between items-center">
                <div
                  className={`cursor-pointer font-secondary font-medium text-[14px] py-5 ${
                    searchData?.paginator?.prev === null
                      ? "opacity-50 cursor-not-allowed"
                      : ""
                  }
                }`}
                  onClick={() => {
                    if (searchData?.paginator?.prev !== null) {
                      const prevPage = searchData?.paginator?.prev;
                      setSearchTable({ ...searchTable, page: prevPage });
                    }
                  }}
                >
                  <ArrowLeftOutlined size={20} className="mr-2" /> Previous page
                </div>
                <div
                  className={`cursor-pointer font-secondary font-medium text-[14px] py-5 ${
                    searchData?.paginator?.next === null
                      ? "opacity-50 cursor-not-allowed"
                      : ""
                  } `}
                  onClick={() => {
                    // Increment the current page by 1
                    if (searchData?.paginator?.next !== null) {
                      const nextPage = searchData?.paginator?.next;
                      setSearchTable({ ...searchTable, page: nextPage });
                    }
                  }}
                >
                  Next page <ArrowRightOutlined size={20} className="ml-2" />
                </div>
              </div>
              <div className="bg-white rounded-2xl p-5 shadow-lg">
                <div className="flex justify-between items-center  gap-3 mb-5">
                  <div className="font-secondary text-[1.6rem] font-normal text-black">
                    Active Dental {searchData?.paginator?.itemCount || 0}
                  </div>

                  <div className="flex gap-3 items-top w-[calc(50%-10px)]">
                    <Cascader
                      size="large"
                      style={{ width: "90%", color: "black" }}
                      options={areaFilterData}
                      onChange={onAreaChange}
                      value={selectedCascaderValue}
                      loading={areaFilterLoader}
                      placeholder={
                        <span>
                          <FilterOutlined style={{ marginRight: 8 }} /> Filter
                        </span>
                      }
                      suffixIcon={null}
                    />
                    {[
                      searchTable?.search,
                      searchTable?.province_id,
                      searchTable?.district,
                      searchTable?.secretariats_id,
                    ].some((value) => value !== "") && (
                      <ClearOutlined
                        className="cursor-pointer text-[#dc2626] text-[20px] mb-5"
                        onClick={() => handleClearFilters()}
                      />
                    )}
                  </div>
                </div>
                {searchLoader ? (
                  <div className="flex justify-center items-center py-[10vh]">
                    <Spin size="small" tip="Loading..." color="#13c2c2" />
                  </div>
                ) : (
                  searchData?.data?.map((item, index) => (
                    <HospitalCard
                      key={index}
                      data={item}
                      onSelect={onSelectHospital}
                    />
                  ))
                )}
                {searchData?.data?.length < 1 && (
                  <NoData title="No Clinic Found" />
                )}
              </div>
            </div>
          </div>
          <div className="my-[10vh]">
            <div className="container">
              <h3 className="font-secondary font-medium text-[2rem]">
                Disclaimer
              </h3>
              <p className="font-primary font-thin text-[1.6rem] mt-8 text-[#666363] text-justify md:text-left">
                We believe that a smile is not just a reflection of good oral
                health, but also a powerful first impression that can leave a
                lasting impact.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SearchPage;
